import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class MailContentKey {
  @IsNumber()
  @Expose()
  keyId!: number;
  @IsString()
  @Expose()
  contentKey!: string;
}
